import { Title, Text, Group, Stack, Card } from '@mantine/core';
import { AnimateDiv } from '@/components/Common/AnimateDiv';

export const Function = () => {
  return (
    <section className="flex flex-col mt-32 max-w-[1520px] mx-auto px-[20px] lg:px-[80px]">
      <AnimateDiv>
        <img src="/home/function.png" alt="" className="w-1/2 lg:w-[400px] mx-auto" />
      </AnimateDiv>
      <AnimateDiv>
        <Title order={2} className="text-2xl lg:text-5xl font-bold text-center mt-10">
          GBase Supportの主な機能
        </Title>
      </AnimateDiv>
      <AnimateDiv>
        <Title order={3} className="text-lg lg:text-3xl pb-12 text-center mt-8 lg:mt-16">
          AI搭載の充実した機能群で
          <br />
          カスタマーサポートの未来を体験してください。
        </Title>
      </AnimateDiv>

      <AnimateDiv>
        <Group justify="space-between" className="mt-10" wrap="nowrap">
          <Stack>
            <Title order={4} className="text-xl lg:text-5xl font-bold">
              高精度AIが実現するスマートな自動応答
            </Title>
            <Text className="text-sm lg:text-xl text-black/60 mt-0 sm:mt-4">
              高度なAIがナレッジベースを活用して質問にスムーズに回答。
            </Text>
          </Stack>
          <img src="/home/idea.png" alt="" className="w-28 md:w-40 lg:w-60 h-28 md:h-40 lg:h-60" />
        </Group>
      </AnimateDiv>

      <Group align="stretch" className="lg:flex-nowrap">
        <AnimateDiv className="rounded-md !bg-gray-50 py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-4 md:px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.9297 3L17.5732 10.1924L16.9092 11.6152H23.5947L10.1699 27.7246L12.7549 18.4219L13.1064 17.1543H6.74707L12.4072 3H20.9297Z"
                stroke="black"
                strokeWidth="2"
              />
              <path d="M14.5 5.5H19.5L20.5 3.5H12.5L7 16.5L10 17L14.5 5.5Z" fill="black" />
            </svg>
            <Title order={5} className="text-base lg:text-2xl font-bold">
              文脈を理解した回答
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              過去のやり取りを踏まえ、より賢く適切な回答を提供します。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-12 mt-8">
            <img src="/home/function1.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
        <AnimateDiv className="rounded-md !bg-[#F8FCFF] py-4 md:py-8 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="16" cy="16" r="3.5" fill="black" stroke="black" />
              <circle cx="29" cy="16" r="2.5" fill="black" stroke="black" />
              <circle cx="3" cy="16" r="2.5" fill="black" stroke="black" />
            </svg>

            <Title order={5} className="text-base lg:text-2xl font-bold">
              賢く自然な会話
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              Agentic RAG搭載で、文脈理解・意思決定・ツール活用を行う、本物のアシスタントのようなAIエージェント。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-12 mt-8">
            <img src="/home/function2.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
      </Group>

      <Group align="stretch" className="mt-4 lg:flex-nowrap">
        <AnimateDiv className="rounded-md !bg-gray-50 py-6 lg:py-10 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-4 md:px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10H28V6.5H4V22H7V10Z" fill="black" />
              <path d="M28 7V22H24.75V24.8496L21.6445 22.2354L21.3652 22H4V7H28Z" stroke="black" strokeWidth="2" />
              <path
                d="M15.2662 19H13.377L15.8308 11.7273H18.171L20.6248 19H18.7356L17.0275 13.5597H16.9707L15.2662 19ZM15.014 16.1378H18.9629V17.473H15.014V16.1378Z"
                fill="black"
              />
            </svg>
            <Title order={5} className="text-base lg:text-2xl font-bold">
              多言語対応
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              多言語対応でグローバルサービスを実現。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-12 md:mx-28 lg:mx-40">
            <img src="/home/function3.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>

        <AnimateDiv className="rounded-md !bg-[#F9F8FF] py-4 md:py-8 px-0 w-full lg:w-1/2">
          <Stack gap="xs" className="px-4 md:px-8">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_ii_4308_1382)">
                <rect x="3" y="3" width="26" height="26" rx="13" fill="#F9F8FF" />
              </g>
              <rect x="4" y="4" width="24" height="24" rx="12" stroke="black" strokeWidth="2" />
              <path d="M8.19133 20L13.5007 14.5L17.0007 18L23.5007 12" stroke="black" strokeWidth="2.5" />
              <defs>
                <filter
                  id="filter0_ii_4308_1382"
                  x="3"
                  y="3"
                  width="26"
                  height="26"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="2" dy="3" />
                  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                  <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4308_1382" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dx="-3" dy="-2" />
                  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
                  <feBlend mode="normal" in2="effect1_innerShadow_4308_1382" result="effect2_innerShadow_4308_1382" />
                </filter>
              </defs>
            </svg>
            <Title order={5} className="text-base lg:text-2xl font-bold">
              充実の管理ツール
            </Title>
            <Text c="dimmed" className="text-sm lg:text-xl">
              Agentic 更新やメンテナンスもシンプルなインターフェースで。
            </Text>
          </Stack>
          <AnimateDiv delay={0.4} className="mx-20 lg:mx-40 mt-10">
            <img src="/home/function4.png" alt="" />
          </AnimateDiv>
        </AnimateDiv>
      </Group>

      <AnimateDiv>
        <Group wrap="nowrap" justify="space-between" className="mt-20">
          <Stack>
            <Title order={4} className="text-xl lg:text-5xl font-bold leading-tight">
              AIアバターで親近感と
              <br />
              ブランド価値を演出
            </Title>
            <Text className="text-sm lg:text-xl text-black/60 mt-0 sm:mt-2 pb-4 sm:pb-0">
              機械的なイメージになりがちなチャットボットをAIアバターで緩和。
            </Text>
          </Stack>
          <img src="/home/hand.png" alt="" className="w-28 md:w-40 lg:w-60 h-28 md:h-40 lg:h-60" />
        </Group>
      </AnimateDiv>

      <Card radius="md" withBorder bg="gray.0" className="w-full border-[#EBEBEB] p-6 lg:p-8 -mt-2">
        <Group justify="space-between">
          <AnimateDiv className="w-full lg:w-1/2">
            <img src="/home/digital-human.jpg" alt="" className="w-full rounded-xl" />
          </AnimateDiv>
          <Stack className="gap-10 lg:gap-20">
            <AnimateDiv>
              <Stack gap="xs">
                <Group wrap="nowrap">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M26 13.5C26 20.1274 20.6274 25.5 14 25.5C7.37258 25.5 2 20.1274 2 13.5C2 6.87258 7.37258 1.5 14 1.5C17.3062 1.5 20.3001 2.83708 22.4705 5"
                      stroke="black"
                      strokeWidth="2"
                    />
                    <path
                      d="M10.298 16.722C10.2794 16.7407 10.2747 16.7593 10.284 16.778C10.2934 16.7967 10.312 16.806 10.34 16.806H13.266C13.3127 16.806 13.35 16.8247 13.378 16.862C13.4154 16.89 13.434 16.9273 13.434 16.974V18.332C13.434 18.3787 13.4154 18.4207 13.378 18.458C13.35 18.486 13.3127 18.5 13.266 18.5H8.08604C8.03937 18.5 7.99737 18.486 7.96004 18.458C7.93204 18.4207 7.91804 18.3787 7.91804 18.332V16.918C7.91804 16.834 7.94137 16.764 7.98804 16.708C8.36137 16.2133 8.62271 15.8773 8.77204 15.7C9.59337 14.6453 10.1767 13.8473 10.522 13.306C11.026 12.5033 11.278 11.8267 11.278 11.276C11.278 10.9587 11.2127 10.716 11.082 10.548C10.9607 10.3707 10.7927 10.282 10.578 10.282C10.3634 10.282 10.1907 10.3707 10.06 10.548C9.92937 10.716 9.86871 10.9353 9.87804 11.206V11.78C9.87804 11.8267 9.85937 11.8687 9.82204 11.906C9.79404 11.934 9.75671 11.948 9.71004 11.948H8.04404C7.99737 11.948 7.95537 11.934 7.91804 11.906C7.89004 11.8687 7.87604 11.8267 7.87604 11.78V11.122C7.91337 10.3567 8.18871 9.74533 8.70204 9.288C9.21537 8.82133 9.86871 8.588 10.662 8.588C11.446 8.588 12.076 8.83533 12.552 9.33C13.0374 9.82467 13.28 10.478 13.28 11.29C13.28 11.7753 13.2007 12.2373 13.042 12.676C12.8927 13.1147 12.6454 13.586 12.3 14.09C12.0387 14.4727 11.5907 15.07 10.956 15.882L10.298 16.722ZM20.0907 14.244C20.1374 14.244 20.1747 14.2627 20.2027 14.3C20.24 14.328 20.2587 14.3653 20.2587 14.412V15.854C20.2587 15.9007 20.24 15.9427 20.2027 15.98C20.1747 16.008 20.1374 16.022 20.0907 16.022H19.6567C19.61 16.022 19.5867 16.0453 19.5867 16.092V18.332C19.5867 18.3787 19.568 18.4207 19.5307 18.458C19.5027 18.486 19.4654 18.5 19.4187 18.5H17.7807C17.734 18.5 17.692 18.486 17.6547 18.458C17.6267 18.4207 17.6127 18.3787 17.6127 18.332V16.092C17.6127 16.0453 17.5894 16.022 17.5427 16.022H14.0427C13.996 16.022 13.954 16.008 13.9167 15.98C13.8887 15.9427 13.8747 15.9007 13.8747 15.854V14.706C13.8747 14.622 13.884 14.552 13.9027 14.496L15.7647 8.84C15.7927 8.74667 15.8534 8.7 15.9467 8.7H17.7247C17.7807 8.7 17.8227 8.71867 17.8507 8.756C17.8787 8.784 17.8834 8.83067 17.8647 8.896L16.1847 14.16C16.1754 14.216 16.194 14.244 16.2407 14.244H17.5427C17.5894 14.244 17.6127 14.2207 17.6127 14.174V12.718C17.6127 12.6713 17.6267 12.634 17.6547 12.606C17.692 12.5687 17.734 12.55 17.7807 12.55H19.4187C19.4654 12.55 19.5027 12.5687 19.5307 12.606C19.568 12.634 19.5867 12.6713 19.5867 12.718V14.174C19.5867 14.2207 19.61 14.244 19.6567 14.244H20.0907Z"
                      fill="black"
                    />
                    <path d="M23 0.5V5.5H18" stroke="black" strokeWidth="2" />
                  </svg>
                  <Title order={5} className="text-base lg:text-2xl font-bold">
                    年中無休でいつでもサポート
                  </Title>
                </Group>
                <Text c="dimmed" className="text-sm lg:text-xl">
                  24時間365日、安定したサポートを提供します
                </Text>
              </Stack>
            </AnimateDiv>
            <AnimateDiv>
              <Stack gap="xs">
                <Group wrap="nowrap">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="3" y="2.5" width="8" height="11" stroke="black" strokeWidth="2" />
                    <rect x="16" y="14.5" width="8" height="11" stroke="black" strokeWidth="2" />
                    <rect x="16" y="2.5" width="8" height="7" stroke="black" strokeWidth="2" />
                    <rect x="3" y="18.5" width="8" height="7" stroke="black" strokeWidth="2" />
                  </svg>
                  <Title order={5} className="text-base lg:text-2xl font-bold">
                    アバターの設定も簡単
                  </Title>
                </Group>
                <Text c="dimmed" className="text-sm lg:text-xl">
                  表情豊かなアバターは設定ひとつでON/OFF切り替え
                </Text>
              </Stack>
            </AnimateDiv>
            <AnimateDiv>
              <Stack gap="xs">
                <Group wrap="nowrap">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14.6204 7.85972L12.5156 5.75487L8.3059 1.54518L2.16943 7.68164L6.37913 11.8913L8.48398 13.9962M13.2199 18.7321L14.0092 19.5214L14.7985 20.3107L19.0082 24.5204L25.1447 18.384L20.935 14.1743L20.1457 13.3849L19.3563 12.5956"
                      stroke="black"
                      strokeWidth="2"
                    />
                    <path
                      d="M25.5908 7.68164L19.4544 1.54518L3.06132 17.9382L3.06823 24.0678L9.19779 24.0747L25.5908 7.68164Z"
                      stroke="black"
                      strokeWidth="2"
                    />
                    <path d="M10.3555 16.7812L7.28724 19.8495" stroke="black" strokeWidth="2" />
                  </svg>

                  <Title order={5} className="text-base lg:text-2xl font-bold">
                    ブランドに合わせたカスタマイズ
                  </Title>
                </Group>
                <Text c="dimmed" className="text-sm lg:text-xl">
                  ブランドに合わせた外見のカスタマイズもご相談ください
                </Text>
              </Stack>
            </AnimateDiv>
            <AnimateDiv>
              <Stack gap="xs">
                <Group wrap="nowrap">
                  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M15.1414 2.5L17.6257 9.31406L24 13.0812L18.0677 17.4721L16.3334 24.5L10.1828 20.3997L2.7367 20.9761L4.86771 14.051L2 7.37933L9.46764 7.1997L15.1414 2.5Z"
                      stroke="black"
                      strokeWidth="2"
                    />
                    <path d="M18 17.5L26 22.5" stroke="black" strokeWidth="2" />
                    <path
                      d="M8 15.1841L10.1651 16.4341M10.7045 10.4998L12.8696 11.7498"
                      stroke="black"
                      strokeWidth="2"
                    />
                  </svg>

                  <Title order={5} className="text-base lg:text-2xl font-bold">
                    まるで人のような回答
                  </Title>
                </Group>
                <Text c="dimmed" className="text-sm lg:text-xl">
                  一人ひとりに合わせた情報や対応で、高い回答品質を実現
                </Text>
              </Stack>
            </AnimateDiv>
          </Stack>
        </Group>
      </Card>
    </section>
  );
};
